/** 检测与剥离 LaTeX 分隔符（$...$ / $$...$$） */

const MATH_PATTERN = /\$\$([\s\S]+?)\$\$|\$([^$\n]+?)\$/;

export function containsMath(text) {
  return MATH_PATTERN.test(String(text || ''));
}

export function stripMathForPlain(text) {
  return String(text || '')
    .replace(/\$\$([\s\S]+?)\$\$/g, '$1')
    .replace(/\$([^$\n]+?)\$/g, '$1');
}

export function parseMathSegments(text) {
  const src = String(text || '');
  const segments = [];
  const regex = /\$\$([\s\S]+?)\$\$|\$([^$\n]+?)\$/g;
  let last = 0;
  let match;
  while ((match = regex.exec(src)) !== null) {
    if (match.index > last) {
      segments.push({ type: 'text', content: src.slice(last, match.index) });
    }
    segments.push({
      type: 'math',
      content: (match[1] || match[2] || '').trim(),
      display: Boolean(match[1]),
    });
    last = regex.lastIndex;
  }
  if (last < src.length) {
    segments.push({ type: 'text', content: src.slice(last) });
  }
  return segments;
}

const DISPLAY_MATH_LINE = /\$\$[\s\S]+?\$\$/;
const INLINE_MATH = /\$[^$\n]+?\$/;

/** 含公式时行高需大于普通文字，避免 KaTeX 分式被裁切 */
export function estimateTextBlockHeight(text, fontSize = 20) {
  const lines = String(text || '').split('\n');
  if (!lines.length) return fontSize;
  let h = 0;
  for (const line of lines) {
    if (DISPLAY_MATH_LINE.test(line)) {
      h += fontSize * 2.75;
    } else if (INLINE_MATH.test(line)) {
      h += fontSize * 2.2;
    } else {
      h += fontSize * 1.25;
    }
  }
  return Math.max(fontSize, Math.ceil(h));
}
